import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import * as _ from 'lodash';

import { ContextualActionComponent } from './contextual-action.component';
import { PACT, PST } from './pim-config';


@Component({
  moduleId: module.id,
  selector: 'published-catalog-action',
  templateUrl: 'published-catalog-action.component.html',
  styleUrls: ['contextual-action.component.scss', 'published-catalog-action.component.scss'],
})
export class PublishedCatalogActionComponent extends ContextualActionComponent implements OnInit {

  primaryActions: Array<any> = [{
    id: PACT.UNPUBLISH.id,
    action: PACT.UNPUBLISH.name,
    type: 'update-status',
    title: 'Unpublish',
    icon: PACT.UNPUBLISH.icon,
    active: true,
    separated: true,
    permissions: ['admin', 'catalog-edit'],
    meta: {
      statusId: PST.UNPUBLISHED.id
    }
  }, {
    id: PACT.EXPORT_SELECTED.id,
    action: PACT.EXPORT_SELECTED.name,
    type: 'export-selected',
    title: 'Export File',
    active: true,
    permissions: ['admin', 'catalog-edit', 'repository'],
    icon: PACT.EXPORT_SELECTED.icon,
  }, {
    id: PACT.EXPORT_SELECTED_TO_RECEIVER.id,
    action: PACT.EXPORT_SELECTED_TO_RECEIVER.name,
    type: 'export-selected',
    title: 'Export to receiver',
    active: true,
    permissions: ['admin', 'catalog-edit', 'repository'],
    icon: PACT.EXPORT_SELECTED_TO_RECEIVER.icon,
  }];

  allowedActions: any[] = [];

  @Output() configureExport: EventEmitter<any> = new EventEmitter();

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnInit() {
    this.allowedActions = this.applyPermissions(this.primaryActions);
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private applyPermissions(actionList: any[]) {
    return _.filter(actionList, (actionItem: any) => {
      return this.hasPermission(actionItem.permissions);
    });
  }
}
